import { render } from "./EventDetails.vue?vue&type=template&id=5521f7fa&scoped=true"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-5521f7fa"

export default script